export default "__VITE_ASSET__CBlDXsiT__"